import conteiner from './conteiner'
import player from './player'

export {
    conteiner,
    player
}



// WEBPACK FOOTER //
// ./src/components/organisms/index.js